import React, { useState } from 'react';
import useLanguage from '../../hooks/useLanguage';

const ReadMoreButton = ({ text, maxLength, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t,} = useLanguage();

  return (
    <div>
      {isExpanded ? (
        <div >
          <div dangerouslySetInnerHTML={{ __html: text }} ></div>
          <button className='border-0 bg-transparent blue-color ms-1' onClick={() => setIsExpanded(!isExpanded)}>{`${t("buttonTitle.readLess")}`}</button>
        </div>
      ) : (
        <div>
          <span className={className}> {text.slice(0, maxLength)} </span>
          {text.length > maxLength && (
            <>  <span>...</span> <button className='border-0 bg-transparent blue-color' onClick={() => setIsExpanded(!isExpanded)}>{`${t("buttonTitle.readMore")}`}</button> </>
          )}
        </div>
      )}
    </div>
  );
};

export default ReadMoreButton;